import { Badge } from "@workspace/web-ui/components/badge";
import { Button } from "@workspace/web-ui/components/button";
import { Separator } from "@workspace/web-ui/components/separator";
import React from "react";
import { MedicationRefillRequestModal } from "~/features/dashboard/components/medication-request";
import { ActiveMedicationProps } from "../types";
import { MedicationPaymentModal } from "~/features/dashboard/components/medication-payment";
import { MedicationRefillPaymentModal } from "~/features/dashboard/components/medication-refill-payment";
import { formatRefillDate } from "@workspace/lib/date";

interface Medication {
  medicalItems: ActiveMedicationProps[];
}

export const getStatusConfig = (item: ActiveMedicationProps) => {
  console.log("getStatusConfig", { item })
  let status: string 

  if (item.is_due) {
    status = "due"
  }else{
     status = item.status
  }

  const statusMap = {
    "active": { color: "bg-[#E6FAF2] text-[#00C781] hover:bg-[#E6FAF2]", text: "Active", status: "active" },
    "new": { color: "bg-[#FEF2FF] text-[#942BA9]", text: "New", status: "new" },
    "due": { color: "bg-[#FEEBEB] text-[#F53535] hover:bg-[#FEEBEB]", text: "Out of supply", status: "due" },
    "refill_requested": { color: "bg-[#FFF6E7] text-[#FFAB1F]", text: "Refill requested", status: "refill_requested" },
  };

  return statusMap[status as keyof typeof statusMap];
};

export default function ActiveMedication({ medicalItems }: Medication) {
  const [payForMed, setPayForMed] = React.useState(false);
  const [payForRefill, setPayForRefill] = React.useState(false);
  const [requestRefill, setRequestRefill] = React.useState(false);

  const [reqMedPrescriptionId, setReqMedPrescriptionId] = React.useState("");

  const [reqRefillPrescriptionId, setReqRefillPrescriptionId] = React.useState("");
  const [reqRefillMedicationId, setReqRefillMedicationId] = React.useState("");

  const [refillPrescriptionId, setRefillPrescriptionId] = React.useState("");
  const [refillMedicationId, setRefillMedicationId] = React.useState("");

  const renderButtons = (item: ActiveMedicationProps) => {
    const statusConfig = getStatusConfig(item)

    if (statusConfig.status === "due" && item.payment_status === "paid") {
      return <div key={item.medication.medication_id} className="p-4 space-y-3 flex flex-col sm:flex-row  justify-between sm:items-center border-[#ECECED] border-b-2">
        <div className="p-0 flex-1">
          <div className="flex items-center gap-2">
            <h3 className="font-medium text-base text-[#2D2F35]">{item.medication.name}</h3>
            <Badge className={`${statusConfig.color} text-xs font-medium`}><span className=" text-[00C781] mr-1 ">{"\u2B24"}</span> {statusConfig.text}</Badge>
          </div>
          <div >
            <h6 className="text-xs sm:text-sm font-normal text-[#202020CC] text-left">
              {item.medication.dosage} <span className="mx-1 text-[#C9C9CC]">{"\u2022"}</span> Next refill date: {item.medication.duration} <span className="mx-1 text-[#C9C9CC]">{"\u2022"}</span> {item.medication.frequency}
            </h6>
          </div>

        </div>
        <Button
          variant="outline"
          onClick={() => {
            setReqRefillMedicationId(item.medication.medication_id)
            setReqRefillPrescriptionId(item.prescription_id || "")
            setRequestRefill(true)
          }}
          className="sm:ml-4 rounded-lg font-semibold w-full sm:w-auto text-sm"
        >
          Request refill
        </Button>
      </div>
    }

    if (statusConfig.status === "refill_requested") {
      return <div key={item.medication.medication_id} className="p-4 space-y-3 flex flex-col sm:flex-row  justify-between sm:items-center border-[#ECECED] border-b-2">
        <div className="p-0 flex-1">
          <div className="flex items-center gap-2">
            <h3 className="font-medium text-base text-[#2D2F35]">{item.medication.name}</h3>
            <Badge className={`${statusConfig.color} text-xs font-medium`}><span className=" text-[00C781] mr-1 ">{"\u2B24"}</span> {statusConfig.text}</Badge>
          </div>
          <div >
            <h6 className="text-xs sm:text-sm font-normal text-[#202020CC] text-left">
              {item.medication.dosage} <span className="mx-1 text-[#C9C9CC]">{"\u2022"}</span> Next refill date: {item.medication.duration} <span className="mx-1 text-[#C9C9CC]">{"\u2022"}</span> {item.medication.frequency}
            </h6>
          </div>

        </div>
        <Button
          onClick={() => {
            setRefillMedicationId(item.medication.medication_id)
            setRefillPrescriptionId(item.prescription_id || "")
            setPayForRefill(true)
          }}
          className="sm:ml-4 rounded-lg font-semibold w-full sm:w-auto text-sm"
        >
          Pay for medication
        </Button>
      </div>
    }

    if (item.payment_status === "not_paid") {
      return <div key={item.medication.medication_id} className="p-4 space-y-3 flex flex-col sm:flex-row  justify-between sm:items-center border-[#ECECED] border-b-2">
        <div className="p-0 flex-1">
          <div className="flex items-center gap-2">
            <h3 className="font-medium text-base text-[#2D2F35]">{item.medication.name}</h3>
            <Badge className={`${statusConfig.color} text-xs font-medium`}><span className=" text-[00C781] mr-1 ">{"\u2B24"}</span> {statusConfig.text}</Badge>
          </div>
          <div >
            <h6 className="text-xs sm:text-sm font-normal text-[#202020CC] text-left">
              {item.medication.dosage} <span className="mx-1 text-[#C9C9CC]">{"\u2022"}</span> Next refill date: {item.medication.duration} <span className="mx-1 text-[#C9C9CC]">{"\u2022"}</span> {item.medication.frequency}
            </h6>
          </div>
        </div>
        <Button
          onClick={() => {
            setReqMedPrescriptionId(item.prescription_id || "")
            setPayForMed(true)
          }}
          className="sm:ml-4 rounded-lg font-semibold w-full sm:w-auto text-sm"
        >
          Pay for medication
        </Button>
      </div>
    }

    return <div key={item.medication.medication_id} className="p-4 space-y-3 flex flex-col sm:flex-row  justify-between sm:items-center border-[#ECECED] border-b-2">
      <div className="p-0 flex-1">
        <div className="flex items-center gap-2">
          <h3 className="font-medium text-base text-[#2D2F35]">{item.medication.name}</h3>
          <Badge className={`${statusConfig.color} text-xs font-medium`}><span className=" text-[00C781] mr-1 ">{"\u2B24"}</span> {statusConfig.text}</Badge>
        </div>
        <div >
          <h6 className="text-xs sm:text-sm font-normal text-[#202020CC] text-left">
            {item.medication.dosage} <span className="mx-1 text-[#C9C9CC]">{"\u2022"}</span> Next refill date: {formatRefillDate(item.due_date)} <span className="mx-1 text-[#C9C9CC]">{"\u2022"}</span> {item.medication.duration}
          </h6>
        </div>
      </div>
    </div>
  }



  return (
    <div className="border rounded-xl shadow-sm bg-white w-full text-center mb-4 ">
      <h3 className="text-lg font-medium text-left p-5 text-[#1A202C]">Active medications</h3>
      <Separator />
      <div className="sm:space-y-4">
        {medicalItems.map((med) => renderButtons(med))}
      </div>

      {/* delete */}
      {/* {reqRefillModal && prescriptionId && medicationId && <MedicationRefillRequestModal open={reqRefillModal} onClose={() => setReqRefillModal(false)} medication_id={medicationId} prescription_id={prescriptionId} />} */}

      {payForMed && reqMedPrescriptionId && <MedicationPaymentModal
        prescription_id={reqMedPrescriptionId}
        open={payForMed}
        onClose={() => setPayForMed(false)}
      />}

      {requestRefill && reqRefillPrescriptionId && reqRefillMedicationId && <MedicationRefillRequestModal
        prescription_id={reqRefillPrescriptionId}
        medication_id={reqRefillMedicationId}
        open={requestRefill}
        onClose={() => setRequestRefill(false)}
      />}

      {payForRefill && refillPrescriptionId && refillMedicationId && <MedicationRefillPaymentModal
        prescription_id={refillPrescriptionId}
        medication_id={refillMedicationId}
        open={payForRefill}
        onClose={() => setPayForRefill(false)}
      />}
    </div>
  )
}
